import declare from "dojo/_base/declare";
import _TemplatedMixin from "dijit/_TemplatedMixin";
import _WidgetBase from "dijit/_WidgetBase";
import template from "dojo/text!./SupplierRequestMasterRightWidget.html";

const SupplierRequestMasterRightWidget = declare([_WidgetBase, _TemplatedMixin], {
	templateString: template,

	supplierRequestMasterName: "",
	numSupplierRequestMaster: 0,
	numProducts: 0,

	_setSupplierRequestMasterNameAttr: { node: "srmName", type: "innerText" },
	_setNumSupplierRequestMasterAttr: { node: "supplierRequestMasterNode", type: "innerText" },
	_setNumProductsAttr: { node: "productsNode", type: "innerText" },
});

export = SupplierRequestMasterRightWidget;
